import { memo } from 'react';

import { type Account } from '@air/api/types';
import { formatFullName } from '@air/utilities';

export type ContentCollectionAccountInformationProps = {
  account: Pick<Account, 'email' | 'firstName' | 'lastName'>;
};

export const ContentCollectionAccountInformation = memo(({ account }: ContentCollectionAccountInformationProps) => {
  return (
    <div
      className="hidden items-center gap-2 ads:text-primary text-14 text-gray-12 md:inline-flex"
      data-testid="CONTENT_COLLECTION_ACCOUNT_INFORMATION"
    >
      <span className="font-medium">{formatFullName(account.firstName, account.lastName)}</span>
      <span>{account.email}</span>
    </div>
  );
});

ContentCollectionAccountInformation.displayName = 'ContentCollectionAccountInformation';
